import { render, staticRenderFns } from "./NewMerchantVisit.vue?vue&type=template&id=13c2c5bb&"
import script from "./NewMerchantVisit.vue?vue&type=script&lang=js&"
export * from "./NewMerchantVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports